import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as projects from '../../../../projects'
import * as engagementCharterComponent from '../engagement-charter-component'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: engagementCharterComponent.RESOURCE.payload.dimension.partialId,
      partialId: engagementCharterComponent.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'The project (tenancy scope) this engagement charter component belongs to.',
    isOptional: false,
    name: 'Project',
    partialId: PartialId.Standard.create('project'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(projects.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
